import { render, staticRenderFns } from "./UserRecordingsTable.vue?vue&type=template&id=cf4b2c4c&scoped=true&"
import script from "./UserRecordingsTable.vue?vue&type=script&lang=js&"
export * from "./UserRecordingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4b2c4c",
  null
  
)

export default component.exports